import config from '../config';
import Reparaturwerkstatt from "../Reparaturwerkstatt";

export default {
    Repair: {
        path: "/reparaturwerkstatt",
        name: "Repair",
        component: Reparaturwerkstatt,
        meta: { roles: config.roles.public },
    },
    Reparaturwerkstatt: {
        path: "/reparaturwerkstatt/:uid",
        name: "Reparaturwerkstatt",
        component: Reparaturwerkstatt,
        meta: { roles: config.roles.public },
    },

};